import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import constants from "../../../constants/constants";
import {
  Card,
  Col,
  Row,
  Spin,
  Form,
  Input,
  Space,
  Button,
  Select,
  message,
  Radio,
  Checkbox,
} from "antd";
import PhoneInput from "react-phone-input-2";
import { fetchApi } from "../../../services/api";
import TextArea from "antd/es/input/TextArea";

const { Option } = Select;

const PotentialRecipientForm = () => {
  const [form] = Form.useForm();
  const [immersionForm] = Form.useForm();
  const [emailValidateStatus, setEmailValidateStatus] = useState({});
  const [emailIdValue, setEmailIdValue] = useState({});
  const [countries, setCountries] = useState([]);
  const [state, setState] = useState([]);
  const [phoneStyles, setPhoneStyles] = useState({});
  const [showOtherReasonForCall, setShowOtherReasonForCall] = useState(false);
  const [otherSource, setOtherSource] = useState(false);
  const [callingFor, setCallingFor] = useState("Self");
  const [serviceForSelf, setServiceForSelf] = useState("");
  const [serviceForOther, setServiceForOther] = useState("");
  const [clientType, setClientType] = useState();

  const history = useHistory();
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  const verticalLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };
  const tailLayout = { wrapperCol: { span: 24 } };
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    fetchCountries();
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      call: callingFor,
    });
  }, [form, callingFor]);

  const handleValidateName = (rule, value, callback) => {
    try {
      if (value) {
        // eslint-disable-next-line no-useless-escape
        let nameValidate = /[`~@#$%^&*,<>;?:"\/\[\]\|{}()=+]/;
        if (nameValidate.test(value) === true) {
          throw new Error(constants.FirstNameInvalid);
        }
      }
      callback(); // < -- this
    } catch (err) {
      callback(err);
    }
  };
  const handleCheckEmail = (fieldName) => {
    const email = emailIdValue[fieldName];

    if (!email) {
      setEmailValidateStatus((prev) => ({
        ...prev,
        [fieldName]: "",
      }));
      return;
    }

    const payload = { email };

    fetchApi("/client/register/check-emails", "post", payload)
      .then((res) => {
        const isSuccess = res?.code === 200;

        setEmailValidateStatus((prev) => ({
          ...prev,
          [fieldName]: isSuccess ? "success" : "error",
        }));

        if (!isSuccess) {
          message.error(res?.message?.email);
        }
      })
      .catch((error) => {
        message.error(error?.message);
      });
  };
  const handleValidatePhone = (fieldName) => (rule, value) => {
    if (value && value.length < 5) {
      setPhoneStyles((prev) => ({
        ...prev,
        [fieldName]: { border: "1px solid rgba(255, 77, 79)" },
      }));

      return Promise.reject(new Error(constants.PhoneNoRegistration));
    }

    setPhoneStyles((prev) => ({
      ...prev,
      [fieldName]: null,
    }));

    return Promise.resolve();
  };
  const handleContactNo = (fieldName, value) => {
    setPhoneStyles((prev) => ({
      ...prev,
      [fieldName]:
        value === "" || value === null || value === undefined
          ? { border: "1px solid rgba(255, 77, 79)" }
          : null,
    }));
  };
  const handleReasonForCall = (val) => {
    setShowOtherReasonForCall(val === "9");
  };
  const handleOtherSource = (val) => {
    setOtherSource(val === "Other");
  };

  // City, state, country
  const fetchCountries = () => {
    fetchApi(`/countries`, "get").then((res) => {
      if (res && res.data && res.data.length > 0) {
        setCountries(res.data);
      } else {
        setCountries([]);
      }
    });
  };
  const onChangeCountry = (val, option) => {
    fetchStates(option?.key);

    form.setFieldsValue({ state: null });
  };
  const fetchStates = (country_code) => {
    fetchApi(`/states/${country_code}`, "get").then((res) => {
      if (res?.data) {
        setState(res?.data);
      } else {
        setState(null);
      }
    });
  };
  const sortedCountries = [...(countries || [])].sort((a, b) => {
    const priority = ["IN", "US"];

    const aIndex = priority.indexOf(a.country_code);
    const bIndex = priority.indexOf(b.country_code);

    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    }

    if (aIndex !== -1) {
      return -1;
    }

    if (bIndex !== -1) {
      return 1;
    }

    return a.country_name.localeCompare(b.country_name);
  });

  const selectFilterOption = (input, option) =>
    option?.label?.toLowerCase().includes(input?.toLowerCase());

  const handleCancel = () => {
    form.resetFields();
    setCallingFor("Self");
    setServiceForSelf("");
    setServiceForOther("");
    setShowOtherReasonForCall(false);
    setOtherSource(false);
    history.goBack();
  };

  const handleValidateLastName = (rule, value, callback) => {
    try {
      if (value) {
        // eslint-disable-next-line no-useless-escape
        let nameValidate = /[`~@#$%^&*,<>;?:!"\/\[\]\|{}()=+\\]/;
        if (nameValidate.test(value) === true || value.length < 2) {
          throw new Error(constants.LastNameInvalid);
        }
      }
      callback(); // < -- this
    } catch (err) {
      callback(err);
    }
  };

  const clearFormFields = () => {
    form.resetFields();
    setServiceForSelf("");
    setServiceForOther("");
    setEmailIdValue({});
    setEmailValidateStatus({});
    setShowOtherReasonForCall(false);
    setOtherSource(false);
  };

  const personalFieldConfig = {
    self: {
      labels: {
        firstName: constants.FirstName,
        lastName: constants.LastName,
        phone: constants.phone,
        email: constants.Email,
      },
      names: {
        firstName: "self_firstname",
        lastName: "self_lastname",
        phone: "self_phnumber-c1",
        email: "self_email",
      },
    },
    other_recipient: {
      labels: {
        firstName: constants.FirstName,
        lastName: constants.LastName,
        phone: constants.phone,
        email: constants.Email,
      },
      names: {
        firstName: "other_recipient_fname",
        lastName: "other_recipient_lname",
        phone: "other_recipient_phone-c1",
        email: "other_recipient_email",
      },
    },

    self_minor: {
      labels: {
        firstName: "Minor's First Name",
        lastName: "Minor's Last Name",
        phone: "Minor's Phone Number",
        email: "Minor's Email",
      },
      names: {
        firstName: "self_minor_fname",
        lastName: "self_minor_lname",
        phone: "self_minor_phone-c1",
        email: "self_minor_email",
      },
    },

    other_minor: {
      labels: {
        firstName: "Minor's First Name",
        lastName: "Minor's Last Name",
        phone: "Minor's Phone Number",
        email: "Minor's Email",
      },
      names: {
        firstName: "other_minor_fname",
        lastName: "other_minor_lname",
        phone: "other_minor_phone-c1",
        email: "other_minor_email",
      },
    },

    self_par: {
      labels: {
        firstName: "Parent's First Name",
        lastName: "Parent's Last Name",
        phone: "Parent's Phone Number",
        email: "Parent's Email",
      },
      names: {
        firstName: "self_par_fname",
        lastName: "self_par_lname",
        phone: "self_par_phone-c1",
        email: "self_par_email",
      },
      checkEmail: false,
    },
    other_par: {
      labels: {
        firstName: "Parent's First Name",
        lastName: "Parent's Last Name",
        phone: "Parent's Phone Number",
        email: "Parent's Email",
      },
      names: {
        firstName: "other_par_fname",
        lastName: "other_par_lname",
        phone: "other_par_phone-c1",
        email: "other_par_email",
      },
      checkEmail: false,
    },

    other_name: {
      labels: {
        firstName: "Your First Name",
        lastName: "Your Last Name",
        phone: constants.phone,
        email: constants.Email,
      },
      names: {
        firstName: "other_fname",
        lastName: "other_lname",
        phone: "other_phone-c1",
        email: "other_email",
      },
    },
  };

  const personalFields = (prefix) => {
    const config = personalFieldConfig[prefix];

    if (!config) return null;

    const { labels, names, checkEmail = true } = config;
    return (
      <>
        <Row gutter={[24, 0]}>
          <Col xs={24} md={12}>
            <Form.Item
              name={names.firstName}
              label={labels.firstName}
              rules={[
                {
                  required: true,
                  message: constants.FillThisField,
                  whitespace: true,
                },
                { validator: handleValidateName },
              ]}
            >
              <Input placeholder={constants.FirstName} />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name={names.lastName}
              label={labels.lastName}
              rules={[
                {
                  required: true,
                  message: constants.FillThisField,
                  whitespace: true,
                },
                { validator: handleValidateLastName },
              ]}
            >
              <Input placeholder={constants.LastName} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[24, 0]}>
          <Col xs={24} md={12}>
            <Form.Item
              name={names.phone}
              label={labels.phone}
              rules={[
                {
                  required: true,
                  message: constants.FillThisField,
                },
                {
                  validator: handleValidatePhone(names.phone),
                },
              ]}
            >
              <PhoneInput
                preferredCountries={["us", "in"]}
                className="w-full"
                style={phoneStyles[names.phone]}
                onChange={(value) => handleContactNo(names.phone, value)}
                placeholder="1(999)123-4567"
                country="in"
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name={names.email}
              label={labels.email}
              validateStatus={emailValidateStatus[names.email]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: constants.FillThisField,
                },
                {
                  type: "email",
                  message: constants.emailVaidationError,
                },
              ]}
            >
              <Input
                placeholder={constants.EmailPlaceholder}
                onChange={(e) => {
                  const value = e.target.value.toLowerCase();

                  setEmailIdValue((prev) => ({
                    ...prev,
                    [names.email]: value,
                  }));
                  setEmailValidateStatus((prev) => ({
                    ...prev,
                    [names.email]: "",
                  }));
                }}
                onBlur={() => {
                  if (checkEmail && emailIdValue[names.email]) {
                    handleCheckEmail(names.email);
                  }
                }}
              />
            </Form.Item>
          </Col>
        </Row>
      </>
    );
  };
  const locationFields = (prefix = "self") => (
    <>
      <Row gutter={[24, 0]}>
        <Col xs={24} md={12}>
          <Form.Item
            name={`${prefix}_country`}
            label="Country"
            rules={[
              {
                required: true,
                message: constants.FillThisField,
              },
            ]}
          >
            <Select
              onChange={onChangeCountry}
              placeholder="Select Country"
              allowClear
              className="w-full"
              showSearch
              filterOption={selectFilterOption}
            >
              {sortedCountries?.map((listCountry) => (
                <Option
                  key={listCountry.country_code}
                  value={listCountry.country_name}
                  label={listCountry.country_name}
                >
                  {listCountry.country_name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            name={`${prefix}_state`}
            label="State"
            rules={[
              {
                required: true,
                message: constants.FillThisField,
              },
            ]}
          >
            <Select
              placeholder="Select State"
              allowClear
              className="w-full"
              showSearch
              filterOption={selectFilterOption}
            >
              {Object.values(state || {})
                .flatMap((country) => country?.states || [])
                .map((item) => (
                  <Option
                    key={item.region_id}
                    value={item.region_name}
                    label={item.region_name}
                  >
                    {item.region_name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      {/* City */}
      <Row gutter={[24, 0]}>
        <Col xs={24} md={12}>
          <Form.Item name={`${prefix}_city`} label="City">
            <Input placeholder="City" className="w-full" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
  const serviceForField = (fieldName, value, setValue) => (
    <>
      <Form.Item
        name={fieldName}
        rules={[
          {
            required: true,
            message: constants.FillThisField,
          },
        ]}
      >
        <div className="flex flex-wrap items-center">
          <span className="text-red-500 text-lg font-bold leading-none">*</span>

          <span className="text-sm font-bold whitespace-nowrap mx-1">
            {constants.ServicesRequiredFor}
          </span>
          <Radio.Group
            className="ml-2"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          >
            <Radio className="text-sm font-bold" value="Adult">
              {constants.Adult}
            </Radio>
            <Radio className="text-sm font-bold" value="Minor">
              {constants.Minor}
            </Radio>
          </Radio.Group>
        </div>
      </Form.Item>
    </>
  );

  const onFinish = (values) => {
    const payload = {
      ...values,
      is_immersion: 1,
    };
    setLoader(true);
    fetchApi("/store-enquiries", "post", payload)
      .then((res) => {
        if (res) {
          form.resetFields();
          history.goBack();
          setLoader(false);
        }
      })
      .catch((error) => {
        message.error(error.message);
        setLoader(false);
      });
  };

  const handleClientType = (e) => {
    setClientType(e.target.value);
  };

  return (
    <div>
      <div className="text-center bg-amber-300 text-lg font-semibold p-3">
        {constants.Subtitle}
      </div>
      <div className="bg-amber-100 text-base font-semibold p-2 mb-3">
        <div className="container mx-auto">
          <Button
            size="small"
            className="text-xs font-semibold bg-sky-800 text-white uppercase"
            onClick={handleCancel}
          >
            {constants.BackBtn}
          </Button>
        </div>
      </div>
      <Spin className="justify-center" spinning={loader} size="large">
        <div className="justify-center flex">
          <Card className="mx-4 w-full md:w-4/5 lg:w-3/4 xl:w-1/2 mt-6">
            <Form
              form={form}
              layout="vertical"
              requiredMark={true}
              onFinish={onFinish}
              {...verticalLayout}
              className="text-black client-details"
            >
              <div className="text-center text-lg font-bold mb-3">
                {constants.PotentialRecipient}
              </div>
              {/* You are calling for */}
              <Form.Item name="call" className="mb-3">
                <div className="flex flex-wrap items-center gap-3">
                  <span className="text-sm font-bold whitespace-nowrap">
                    {constants.YouAreCallingFor}
                  </span>

                  <Radio.Group
                    value={callingFor}
                    onChange={(e) => setCallingFor(e.target.value)}
                    onChange={(e) => {
                      setCallingFor(e.target.value);
                      clearFormFields();
                    }}
                  >
                    <Radio className="text-sm font-bold" value="Self">
                      {constants.Self}
                    </Radio>
                    <Radio className="text-sm font-bold" value="Other">
                      {constants.Other}
                    </Radio>
                  </Radio.Group>
                </div>
              </Form.Item>

              {/* Services required for self */}
              {callingFor !== "Other" &&
                serviceForField("service-1", serviceForSelf, setServiceForSelf)}

              {/* Calling for self-adult */}
              {serviceForSelf === "Adult" &&
                callingFor !== "Other" &&
                personalFields("self")}

              {/* Calling for self-minor */}
              {serviceForSelf === "Minor" &&
                callingFor !== "Other" &&
                personalFields("self_minor")}
              {serviceForSelf === "Minor" &&
                callingFor !== "Other" &&
                personalFields("self_par")}

              {callingFor === "Other" && personalFields("other_name")}

              {/* Location for self*/}
              {callingFor !== "Other" && locationFields("self")}

              {/* Location for other */}
              {callingFor === "Other" && locationFields("other")}

              {/* Services required for other */}
              {callingFor === "Other" &&
                serviceForField(
                  "service-2",
                  serviceForOther,
                  setServiceForOther,
                )}

              {/* Calling for other-adult */}
              {serviceForOther === "Adult" &&
                callingFor === "Other" &&
                personalFields("other_recipient")}

              {/* Calling for other-minor */}
              {serviceForOther === "Minor" &&
                callingFor === "Other" &&
                personalFields("other_minor")}
              {serviceForOther === "Minor" &&
                callingFor === "Other" &&
                personalFields("other_par")}

              {callingFor === "Other" && locationFields("other2")}

              <Form.Item
                name="client_type"
                className="mb-3"
                rules={[
                  {
                    required: true,
                    message: constants.FillThisField,
                  },
                ]}
              >
                <div className="flex flex-wrap items-center">
                  <span className="text-red-500 text-lg font-bold leading-none">
                    *
                  </span>

                  <span className="text-sm font-bold whitespace-nowrap ml-1 mr-2">
                    {constants.WorkbookType}
                  </span>
                  <Radio.Group onChange={handleClientType}>
                    <Radio className="text-sm font-bold" value={1}>
                      {constants.addict}
                    </Radio>
                    <Radio className="text-sm font-bold" value={0}>
                      {constants.NotAnAddict}
                    </Radio>
                  </Radio.Group>
                </div>
              </Form.Item>

              {/* Choose the service */}
              <Form.Item
                name={
                  callingFor === "Other" ? "other_checkbox" : "self_checkbox"
                }
                label={<span>{constants.ChooseTheService}</span>}
                rules={[
                  {
                    required: true,
                    message: constants.FillThisField,
                  },
                ]}
              >
                <Checkbox.Group className="w-full">
                  <Row gutter={[24, 8]} className="w-full">
                    <Col xs={24} sm={12}>
                      <Checkbox value="Alcohol" disabled={clientType !== 1}>{constants.Alcohol}</Checkbox>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Checkbox value="Family">{constants.Family}</Checkbox>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Checkbox value="Drug" disabled={clientType !== 1}>{constants.Drug}</Checkbox>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Checkbox value="Emotional/General">
                        {constants.EmotionalGeneral}
                      </Checkbox>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Checkbox value="Gambling" disabled={clientType !== 1}>
                        {constants.GamblingTest}
                      </Checkbox>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Checkbox value="Mental Health/Psychiatric">
                        {constants.MentalHealthPsychiatric}
                      </Checkbox>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Checkbox value="Screen Addiction">
                        {constants.ScreenAddiction}
                      </Checkbox>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Checkbox value="Lifestyle">
                        {constants.Lifestyle}
                      </Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Form.Item>

              <Form.Item label="What is the best time to contact you?" name="availability_slot">
                <Radio.Group
                  options={constants.ContactTimeOptions}
                />
              </Form.Item>

              {/* Reason for contacting us */}
              <Form.Item
                name={callingFor === "Other" ? "other_reason" : "self_reason"}
                label="Reason for contacting us?"
                rules={[
                  {
                    required: true,
                    message: constants.FillThisField,
                  },
                ]}
              >
                <Select
                  placeholder="--Please choose an option--"
                  allowClear
                  className="w-full"
                  onChange={handleReasonForCall}
                >
                  {constants.ReasonForCallOptions.map((val) => (
                    <Option key={val.value} value={val.value}>
                      {val.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              {showOtherReasonForCall ? (
                <Form.Item
                  name={"other-reason-textbox"}
                  label={constants.OtherDetails}
                >
                  <Input type="text" />
                </Form.Item>
              ) : null}

              {/* Concerns */}
              <Form.Item
                name={callingFor === "Other" ? "other_message" : "self_message"}
                label="In a few words, please tell us more about your concerns."
                rules={[
                  {
                    required: true,
                    message: constants.FillThisField,
                  },
                  {
                    whitespace: true,
                    message: "Please enter your concerns.",
                  },
                  {
                    min: 5,
                    message: "Please enter at least 5 characters.",
                  },
                ]}
              >
                <TextArea rows={3} />
              </Form.Item>

              {/* How did you hear about us */}
              <Form.Item
                name={
                  callingFor === "Other" ? "other_referral" : "self_referral"
                }
                label="How did you hear about us?"
                rules={[
                  {
                    required: true,
                    message: constants.FillThisField,
                  },
                ]}
              >
                <Select
                  placeholder="--Please choose an option--"
                  allowClear
                  className="w-full"
                  onChange={handleOtherSource}
                >
                  {constants.SourceOfInfo.map((val) => (
                    <Option key={val.value} value={val.label}>
                      {val.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              {otherSource ? (
                <Form.Item
                  name={
                    callingFor === "Other"
                      ? "other_other_source"
                      : "self_other_source"
                  }
                  label={constants.Other}
                >
                  <Input type="text" />
                </Form.Item>
              ) : null}
              <Form.Item {...tailLayout}>
                <Space className="float-right">
                  <Button size="middle" onClick={() => handleCancel()}>
                    {constants.CancelBTN}
                  </Button>
                  <Button
                    size="middle"
                    className="bg-sky-800 text-white uppercase"
                    htmlType="submit"
                  >
                    {constants.Save}
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </Spin>
    </div>
  );
};

export default PotentialRecipientForm;
